import NotFound from "../screens/common/NotFound";
import Error from "../screens/common/Error";
import Login from "../screens/Login";
import Transactions from "../screens/Transactions";
import Merchants from "../screens/Merchants/Merchants";
import Commissions from "../screens/Commissions/Commissions";
import Reports from "../screens/Reports/Reports";
import Resellers from "../screens/Resellers/Resellers";

const routes = [
	{
		path: "/invalid",
		component: NotFound,
		name: "NotFound",
		exact: true,
		requireAuth: false,
	},
	{
		path: "/error",
		component: Error,
		name: "Error",
		exact: true,
		requireAuth: false,
	},
	{
		path: "/login",
		component: Login,
		name: "Login",
		exact: true,
		requireAuth: false,
	},
	{
		path: "/transactions/:merchant",
		component: Transactions,
		name: "Transactions",
		exact: true,
		requireAuth: true,
	},
	{
		path: "/merchants",
		component: Merchants,
		name: "Merchants",
		exact: true,
		requireAuth: true,
	},
	{
		path: "/commissions",
		component: Commissions,
		name: "Commissions",
		exact: true,
		requireAuth: true,
	},
	{
		path: "/reports",
		component: Reports,
		name: "Reports",
		exact: true,
		requireAuth: true,
	},
	{
		path: "/resellers",
		component: Resellers,
		name: "Resellers",
		exact: true,
		requireAuth: true,
	},
];

export default routes;
